(function () {
  function getFixedHeaderOffset() {
    /* Mirrors the CSS in product-sticky-tabs-xc.css / header-home.css:
       the site header reserves ~5.6rem + 24px, plus a 12px gap. */
    var rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    return (5.6 * rootFontSize) + 24 + 12;
  }

  function initPillNav(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var links = Array.prototype.slice.call(root.querySelectorAll('.th-pill-nav__item')).filter(function (link) {
      var exists = !!document.getElementById(link.dataset.target);
      if (!exists) link.hidden = true;
      return exists;
    });

    if (!links.length) {
      root.hidden = true;
      return;
    }

    /* Floating sticky behavior.
       Native position: sticky cannot remain visible here because the
       Shopify section wrapper is only as tall as the navigation itself. */
    var stickyShell = root.querySelector('.th-pill-nav-shell.is-sticky');

    if (stickyShell) {
      var stickyTop = getFixedHeaderOffset();
      var triggerPoint = 0;
      var animationFrame = null;

      var updateStickyState = function () {
        var shouldFix = window.scrollY >= triggerPoint;

        if (shouldFix && !stickyShell.classList.contains('is-fixed')) {
          root.style.minHeight = root.getBoundingClientRect().height + 'px';
          stickyShell.classList.add('is-fixed');
        } else if (!shouldFix && stickyShell.classList.contains('is-fixed')) {
          stickyShell.classList.remove('is-fixed');
          root.style.minHeight = '';
        }
      };

      var measureStickyPoint = function () {
        stickyShell.classList.remove('is-fixed');
        root.style.minHeight = '';

        triggerPoint = root.getBoundingClientRect().top + window.scrollY - stickyTop;

        updateStickyState();
      };

      var requestStickyUpdate = function () {
        if (animationFrame !== null) return;

        animationFrame = window.requestAnimationFrame(function () {
          animationFrame = null;
          updateStickyState();
        });
      };

      window.requestAnimationFrame(measureStickyPoint);
      window.addEventListener('scroll', requestStickyUpdate, { passive: true });
      window.addEventListener('resize', measureStickyPoint);
      window.addEventListener('load', measureStickyPoint, { once: true });
    }

    var setActive = function (activeLink) {
      links.forEach(function (link) {
        var active = link === activeLink;
        link.classList.toggle('is-active', active);

        if (active) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var targetId = link.dataset.target;
        var target = document.getElementById(targetId);

        if (!target) return;

        event.preventDefault();
        setActive(link);

        var navHeight = stickyShell ? stickyShell.getBoundingClientRect().height : 44;
        var stickyOffset = getFixedHeaderOffset() + navHeight + 10;
        var targetTop = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset;

        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });
      });
    });

    // tabs can be hidden later (e.g. Reviews with no content), so resolve the list on every update
    var getTargets = function () {
      return links
        .map(function (link) {
          var target = document.getElementById(link.dataset.target);
          return target && !link.hidden ? { link: link, target: target } : null;
        })
        .filter(Boolean);
    };

    // Scroll-position based: the active tab is the last section whose top has passed the line just under
    // the header + pill nav. Above the first section (or on load), the first tab (Overview) is active.
    var clickLock = false;
    var clickLockTimer = null;

    var updateActive = function () {
      var observedTargets = getTargets();
      if (clickLock || !observedTargets.length) return;
      var navHeight = stickyShell ? stickyShell.getBoundingClientRect().height : 44;
      var line = getFixedHeaderOffset() + navHeight + 40;
      var current = observedTargets[0];

      observedTargets.forEach(function (item) {
        if (item.target.getBoundingClientRect().top <= line) current = item;
      });

      // bottom of the page: the last section may never reach the line
      if (window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 4) {
        current = observedTargets[observedTargets.length - 1];
      }

      setActive(current.link);
    };

    var activeTicking = false;
    var requestActiveUpdate = function () {
      if (activeTicking) return;
      activeTicking = true;
      window.requestAnimationFrame(function () {
        activeTicking = false;
        updateActive();
      });
    };

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        clickLock = true;
        window.clearTimeout(clickLockTimer);
        clickLockTimer = window.setTimeout(function () {
          clickLock = false;
          updateActive();
        }, 900);
      });
    });

    window.addEventListener('scroll', requestActiveUpdate, { passive: true });
    window.addEventListener('resize', requestActiveUpdate);
    window.addEventListener('load', updateActive, { once: true });
    updateActive();
  }

  function initAll() {
    document.querySelectorAll('.th-pill-nav-section').forEach(initPillNav);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState !== 'loading') {
    initAll();
  }
})();
